(function () {
    'use strict';

    angular.module('app.shared.modals').service('modalService', ['$modal', '$rootScope',
        function ($modal, $rootScope) {

            var modalDefaults = {
                backdrop: true,
                keyboard: false,
                modalFade: false,
                windowClass: 'asa-msg-modal',
                templateUrl: '/shared/modals/asaModal.html'
            };

            var modalOptions = {
                modalType: 3, //2 - 2 buttons (ok, cancel), 3 - 3 buttons, 1 - 1 button (ok) 
                messageClass: 'primary',  // 'success', 'warning', 'danger', 'info'
                okButtonText: 'OK',
                useProceedIcon: false,
                useBackIcon: false,
                cancelButtonText: 'Cancel',
                proceedButtonText: 'Proceed',
                newTabButtonText: 'Open New Tab',
                headerText: 'Confirm',
                bodyText: 'Perform this action?',
                hasGrid: false,
                autoLogoutText: 'Due to inactivity, you will be automatically logged out in {0} seconds.',
                autoLogout: false,
                showOpenTabButton: false,
                gridColumns: [],
                gridRows: []
            };

            this.showModal = function (customModalDefaults, customModalOptions) {
                if (!customModalDefaults) customModalDefaults = {};
                customModalDefaults.backdrop = 'static';
                if (customModalOptions.modalType > 1 && !customModalOptions.headerText) {
                    customModalOptions.headerText = 'Confirm';
                }
                if (customModalOptions.modalType === 1) {
                    switch (customModalOptions.messageClass) {
                        case 'info':
                            customModalOptions.headerText = 'Information';
                            break;
                        case 'success':
                            customModalOptions.headerText = 'Success';
                            break;
                        case 'warning':
                            customModalOptions.headerText = 'Warning';
                            break;
                        case 'danger':
                            customModalOptions.headerText = 'Error';
                            break;
                    }
                }
                return this.show(customModalDefaults, customModalOptions);
            };

            this.show = function (customModalDefaults, customModalOptions) {
                var tempModalDefaults = {};
                var tempModalOptions = {};

                //Map angular-ui modal custom defaults to modal defaults defined in service
                angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

                //Map modal.html $scope custom properties to defaults defined in service
                angular.extend(tempModalOptions, modalOptions, customModalOptions);

                if (!tempModalDefaults.controller) {
                    tempModalDefaults.controller = ['$scope', '$modalInstance', function ($scope, $modalInstance) {

                        customModalDefaults.closeModal = function () {
                            $modalInstance.close('ok');
                        };

                        // This is custom code for the Auto Logout modal
                        if (customModalOptions.autoLogout == true) {
                            tempModalOptions.getCountdown = function () { return tempModalOptions.bodyText; };
                            tempModalOptions.bodyText = tempModalOptions.autoLogoutText.replace('{0}', '10');
                            var secondsLeft = 60;
                            var interval = setInterval(function () {
                                tempModalOptions.bodyText = tempModalOptions.autoLogoutText.replace('{0}', --secondsLeft);
                                $rootScope.$digest();
                                if (secondsLeft <= 0) {
                                    tempModalOptions.bodyText = tempModalOptions.autoLogoutText.replace('{0}', 0);
                                    $rootScope.$digest();
                                    clearInterval(interval);
                                    $modalInstance.close('ok');
                                }
                            }, 1000);
                        }

                        $scope.modalOptions = tempModalOptions;
                        $scope.modalOptions.ok = function (result) {
                            $modalInstance.close('ok');
                        };

                        $scope.modalOptions.proceed = function (result) {
                            $modalInstance.close('proceed');
                        };

                        $scope.modalOptions.cancel = function (result) {
                            $modalInstance.close('cancel');
                        };

                        $scope.modalOptions.openTab = function (result) {
                            $modalInstance.close('openTab');
                        };

                        $scope.modalOptions.copyText = function (str) {
                            var dummy = document.createElement("textarea");                           
                            document.body.appendChild(dummy);                           
                            dummy.value = str;
                            dummy.select();
                            document.execCommand("copy");
                            document.body.removeChild(dummy);
                        }

                        $scope.modalOptions.printData = function () {
                            var header = document.getElementById("printHeader")
                            var headerClone = header.cloneNode(true);

                            var table = document.getElementById("printTable")
                            var tableClone = table.cloneNode(true);

                            var $printSection = document.getElementById("printSection");

                            if (!$printSection) {
                                var $printSection = document.createElement("div");
                                $printSection.id = "printSection";
                                document.body.appendChild($printSection);
                            }

                            $printSection.innerHTML = "";
                            $printSection.appendChild(headerClone);
                            $printSection.appendChild(tableClone);
                            window.print();
                        };

                        $scope.modalOptions.swapDoNotAsk = function () {
                            customModalOptions.dontAsk = (customModalOptions.dontAsk != null) ? !customModalOptions.dontAsk : true;
                        }

                    }];
                } else {
                    $modal.modalOptions = tempModalOptions;
                    $modal.modalDefaults = tempModalDefaults;
                }

                return $modal.open(tempModalDefaults).result;
            };

        }]);
})();